<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="pa-6 text-center">
          <v-card-title class="justify-center mb-4">
            <v-icon color="success" size="64" class="mb-4"
              >mdi-check-circle</v-icon
            >
          </v-card-title>
          <v-card-title class="justify-center text-h5 mb-2">
            Платеж успешно обработан
          </v-card-title>
          <v-card-text>
            <p class="text-body-1 mb-4">
              Ваш платеж успешно обработан. Баланс вашей компании будет пополнен
              в течение нескольких минут.
            </p>
            <p class="text-body-2 text--secondary mb-6">
              Обычно это занимает от 1 до 5 минут. После пополнения баланса вы
              получите уведомление.
            </p>
            <v-divider class="my-4"></v-divider>
            <v-btn color="primary" large @click="goToHome" class="mt-2">
              Вернуться в личный кабинет
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "BalanceTopupSuccessView",
  methods: {
    goToHome() {
      const user = this.$store.getters.user;
      if (!user) {
        this.$router.push({ name: "home" });
        return;
      }

      switch (user.role) {
        case "company-user":
        case "company-owner":
          this.$router.push({ name: "company-patients" });
          break;
        case "admin":
          this.$router.push({ name: "admin-users" });
          break;
        case "manager":
          this.$router.push({ name: "manager-users" });
          break;
        default:
          this.$router.push({ name: "home" });
      }
    },
  },
};
</script>
